import type { statistics as en } from '@/i18n/locales/en/statistics';
import type { Translation } from '@/i18n/types';

export const statistics: Translation<typeof en> = {
  panelType: {
    series: 'Séries',
    sessions: 'Sessões',
    availability: 'Disponibilidade',
  },
  status: {
    forbidden: 'Não tens permissão para ver isto.',
    insufficientData:
      'Ainda não há pessoas suficientes com dados para mostrar este grupo sem identificar ninguém.',
    noMetrics: 'Sem métricas neste intervalo.',
    noData: 'Sem dados neste intervalo.',
    noSessions: 'Sem sessões neste intervalo.',
    noAvailability: 'Nenhum dado registado.',
    loadFailed: 'Não foi possível carregar este painel: {{message}}',
  },
  target: {
    you: 'Tu',
    department: 'Departamento {{name}}',
    company: 'Empresa {{name}}',
  },
  table: {
    date: 'Data',
    type: 'Tipo',
    duration: 'Duração',
    calories: 'Calorias',
    avgHeartRate: 'FC média',
    minutes: '{{count}} min',
    metric: 'Métrica',
    source: 'Origem',
    first: 'Primeiro',
    last: 'Último',
    days: 'Dias',
  },
  detailLink: 'Ver detalhes',
  range: {
    last7Days: 'Últimos 7 dias',
    last30Days: 'Últimos 30 dias',
    last90Days: 'Últimos 90 dias',
    thisWeek: 'Esta semana',
    thisMonth: 'Este mês',
    custom: 'Personalizado…',
    from: 'De',
    to: 'Até',
  },
};
